import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from '../error-handler.service';

export type ConsentType = 'ANALYTICS_COOKIES' | 'MAP_DISCLAIMER';

export interface SubmitConsentRequest {
  type: ConsentType;
  value: string;
}

export interface SubmitConsentResponse {
  success?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ConsentApiService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  submitConsent(type: ConsentType, value: string = '1'): Observable<SubmitConsentResponse> {
    return this.http
      .post<SubmitConsentResponse>(`${this.apiUrl}/api/user/consent`, { 
        type,
        value 
      })
      .pipe(
        catchError((err) => {
          this.errorHandler.handleError(err);
          return throwError(() => err);
        }),
      );
  }
}

